import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { usePageContext } from '@/features/context/PageContext';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './header/Breadcrumb';




const MainLayout = () => {
  // États pour la gestion de la barre latérale
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { title } = usePageContext();  // Récupérer les valeurs du contexte

  const defaultTitle = title || "Tableau de bord";

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Barre latérale avec états */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      
      {/* Contenu principal */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          title={defaultTitle}
          setSidebarOpen={setSidebarOpen}
        />
        
        {/* Zone de contenu principal utilisant Outlet pour le routage */}
        <main className="flex-1 overflow-y-auto bg-gray-50 p-4 sm:p-6 lg:p-8">
          <Breadcrumb />
          <Outlet />
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;